import script from "./AgentLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentLayout.vue?vue&type=script&setup=true&lang=js"

import "./AgentLayout.vue?vue&type=style&index=0&id=84987e48&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84987e48"]])

export default __exports__